// extracted by mini-css-extract-plugin
export default {"container":"title-background_container__2XBkC","title":"title-background_title__1e8ap","forumPage":"title-background_forumPage__2ke2-","louve":"title-background_louve__1dDta"};